import React, { useState } from "react";

const ECOSYSTEM_ITEMS = [
  {
    id: "iot",
    iconSrc: "/images/physical-ai/ecosystem-iot.png",
    title: "IoT Integration",
    subtitle: "Connect with existing infrastructure and systems",
    iconSize: "w-[24px] h-[24px]",
  },
  {
    id: "vision",
    iconSrc: "/images/physical-ai/ecosystem-vision.png",
    title: "Vision & Sensing",
    subtitle: "Understand and navigate complex environments",
    iconSize: "w-[24px] h-[24px]",
  },
  {
    id: "autonomy",
    iconSrc: "/images/physical-ai/ecosystem-autonomy.png",
    title: "AI Autonomy",
    subtitle: "Perception, mapping and task execution",
    iconSize: "w-[24px] h-[26px]",
  },
  {
    id: "cloud",
    iconSrc: "/images/physical-ai/ecosystem-cloud.png",
    title: "Cloud & Fleet Management",
    subtitle: "Monitor, manage and scale robot operations",
    iconSize: "w-[26px] h-[20px]",
  },
];

export default function ConnectedEcosystemSection() {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section
      className="w-full py-16 sm:py-20 lg:py-24"
      style={{ backgroundColor: "rgba(255, 255, 255, 1)" }}
    >
      <div className="mx-auto max-w-[1380px] px-4 sm:px-6 lg:px-8">
        {/* Header row */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6 pb-12">
          <div>
            <p className="text-[12px] font-bold tracking-[2.5px] uppercase text-[#94A3B8]">
              A CONNECTED ECOSYSTEM
            </p>
            <h2 className="mt-2 text-[32px] sm:text-[38px] lg:text-[42px] font-bold tracking-tight text-[#0B132B]">
              Powered by AI, IoT and real-world data.
            </h2>
          </div>

          <div className="flex items-center gap-6 lg:max-w-[490px]">
            {/* Vertical divider on desktop */}
            <div className="hidden lg:block w-[1px] h-12 bg-[#CBD5E1]/80 shrink-0" />
            <p className="text-[13.5px] sm:text-[14.5px] leading-[22px] text-[#64748B]">
              Our robots connect seamlessly with IoT devices, cameras and sensors to understand environments and perform tasks autonomously.
            </p>
          </div>
        </div>

        {/* 4 Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {ECOSYSTEM_ITEMS.map((item) => {
            const isHovered = hoveredId === item.id;

            return (
              <div
                key={item.id}
                onMouseEnter={() => setHoveredId(item.id)}
                onMouseLeave={() => setHoveredId(null)}
                className="group relative flex flex-col justify-between p-5 sm:p-6 transition-all duration-300 ease-out cursor-default"
                style={{
                  minHeight: "163px",
                  borderRadius: "16.47px",
                  border: "1.83px solid rgba(255, 255, 255, 1)",
                  background: isHovered
                    ? "linear-gradient(180deg, rgba(233, 242, 255, 1) 0%, rgba(195, 234, 254, 1) 100%)"
                    : "rgba(248, 251, 255, 1)",
                  boxShadow: isHovered
                    ? "0px 1.83px 7.4px rgba(49, 112, 247, 0.2)"
                    : "0px 1.83px 3.66px rgba(0, 0, 0, 0.05)",
                  transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
                }}
              >
                {/* Icon Container */}
                <div className="mb-4">
                  <div
                    className="flex items-center justify-center transition-all duration-300"
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      background: isHovered
                        ? "linear-gradient(135deg, #00D2EE 0%, #155DFC 100%)"
                        : "#F4F5F7",
                      boxShadow: isHovered
                        ? "0px 4px 14px rgba(21, 93, 252, 0.35)"
                        : "none",
                    }}
                  >
                    <img
                      src={item.iconSrc}
                      alt={item.title}
                      className={`${item.iconSize} object-contain transition-all duration-300`}
                      style={{
                        filter: isHovered ? "brightness(0) invert(1)" : "none",
                      }}
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex flex-col gap-1.5">
                  <h3
                    className="text-[17px] sm:text-[18px] font-bold leading-tight transition-colors duration-300"
                    style={{
                      color: isHovered ? "#007AFF" : "#0F172A",
                    }}
                  >
                    {item.title}
                  </h3>
                  <p className="text-[13px] sm:text-[13.5px] leading-[19px] text-[#475569]">
                    {item.subtitle}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
